export default "__VITE_ASSET__DSY37UCz__"